import { isMobile } from 'react-device-detect';

export default { showMobileVersion: showMobileVersion };

/**
 * Comparison of window.innerWidth with 575 because of extra check,
 * isMobile is not returning true if browser on desktop fits mobile grid
 * 575 is bootstrap viewport limit for switching to mobile grid
 */
function showMobileVersion () {
  return isMobile || window.innerWidth <= 575;
}



// WEBPACK FOOTER //
// ./src/controllers/MainController.js